import { Input } from '@angular/core';
import { ThumbSourceFactoryService } from '../../services/thumb-source-factory.service';

export declare interface CartItem {
    attributes: {
        extra_fields: Array<any>,
        components: Array<any>,
        gettable: boolean,
        deliverable: boolean,
        editable: boolean,
        removable: boolean
    };
    categories: Array<any>;
    conditions: any;
    ean: string;
    extra_fields: any;
    id: string;
    row_id: string;
    image: string;
    image_cycle: string;
    name: string;
    original_price: number;
    price: number;
    quantity: number;
    sku: string;
    split_group: string;
    tags: Array<any>;
    type: string;
    urls: Array<{
        url: string
    }>;
}

export abstract class AbstractItemRow {
    @Input() item: CartItem;
    protected thumbFactory: ThumbSourceFactoryService;

    /**
     * This build thumb source from item model attributes.
     **/
    public getThumbSource(): string {

        if(this.item.image_cycle !== undefined && this.item.image_cycle !== null)
        {
            return this.thumbFactory.make(this.item.image_cycle, 86, 100);
        }

        return this.thumbFactory.make(this.item.image, 86, 100);
    }

    /**
     * This build URL from item model attributes.
     **/
    public getUrl(): string {
        const urls = (this.item.urls || []);
        if (urls.length === 0) {
            return '';
        }

        return urls[0].url;
    }

    /**
     * Item extra fields length is greater than zero.
     **/
    public hasExtraFields(): boolean {
        return Object.keys(this.item.extra_fields).length > 0;
    }

    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getExtraFields() {
        return Object
            .keys(this.item.extra_fields)
            .map(slug => this.item.extra_fields[slug]);
    }

    /**
     * Item extra fields length is greater than zero.
     **/
    public hasAttributesExtraFields(): boolean {
        return Object.keys(this.item.attributes.extra_fields).length > 0;
    }

    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getAttributesExtraFields() {
        return Object
            .keys(this.item.attributes.extra_fields)
            .map(slug => {
                return {
                    slug: slug,
                    value: this.item.attributes.extra_fields[slug]
                };
            });
    }

    /**
     * Item components attributes length is greater than zero.
     **/
    public hasComponents() {
        return Object.keys(this.item.attributes.components).length > 0;
    }

    /**
     * Get components from cart item attributes.
     **/
    public getComponents() {
        return this.item.attributes.components;
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/shared/components/abstract-item-row/abstract-item-row.ts